import { useState } from 'react';
import styled from 'styled-components';
import { GroupsSection } from '../../common/main/groups/GroupsSection';
import { GroupEditModal } from '../../admin/groups/GroupEditModal';
import { groupApi } from '../../../core/api/rtk-query/group.api';
import { userApi } from '../../../core/api/rtk-query/user.api';
import { useAuth } from '../../../hooks/useAuth';
import toast from 'react-hot-toast';

const Wrap = styled.div`display:grid; gap:12px;`;
const Header = styled.div`display:flex; align-items:center; gap:12px;`;
const Grow = styled.div`flex:1;`;
const Btn = styled.button`background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;`;

type GroupDraft = { id?: string; name: string; startTime: string; endTime: string };

export const TeacherGroupsPage = () => {
  const [editorOpen, setEditorOpen] = useState(false);
  const [createGroup] = groupApi.useCreateGroupMutation();
  const [addUserToGroup] = groupApi.useAddUserToGroupMutation();
  const { userId } = useAuth();

  const openCreate = () => {
    setEditorOpen(true);
  };

  const handleSave = async (draft: GroupDraft) => {
    try {
      const result = await createGroup({
        name: draft.name,
        startTime: draft.startTime,
        endTime: draft.endTime,
      }).unwrap();
      
      // Привязываем текущего преподавателя к созданной группе
      if (result.id && userId) {
        await addUserToGroup({
          userId: userId,
          groupId: result.id,
        }).unwrap();
      }
      
      toast.success('Курс создан');
      setEditorOpen(false);
    } catch (error) {
      toast.error('Ошибка при создании курса');
    }
  };

  return (
    <Wrap>
      <Header>
        <h2 style={{margin:0}}>Мои курсы</h2>
        <Grow />
        <Btn onClick={openCreate}>Создать курс</Btn>
      </Header>
      <GroupsSection />
      {editorOpen && (
        <GroupEditModal
          initial={{ id: '', name: '', startTime: new Date().toISOString(), endTime: new Date(Date.now()+86400000*120).toISOString() }}
          onClose={() => setEditorOpen(false)}
          onSave={handleSave}
        />
      )}
    </Wrap>
  );
};
